












import {Vue, Component, Prop} from 'vue-property-decorator'
import {Action, State} from 'vuex-class'
import Utils from '../../utils'
import {EventBus} from '@/main'
import {DialogState, PopupState} from '../../store'
import moment from 'moment'
import {
  BookRequest,
  VehicleSlot,
  AvailabilityRequest,
  AvailabilityResponse,
  ReservationResponse,
  BookTimeSelectRequest,
} from '@/lib/kepler/interfaces'
import VehicleBookingDateTimeSelect from './VehicleBookingDateTimeSelect.vue'
import DateHelper from '@/lib/DateHelper'
import {ProfileState} from '@/store/modules/profile'
import VehicleBookingAddMemoDialog from '@/views/Vehicle/VehicleBookingAddMemoDialog.vue'
import VehicleConfirmBooking from '@/views/Vehicle/VehicleConfirmBooking.vue'
import QuickBookDialog from '@/components/QuickBookDialog.vue'

@Component({
  components: {
    Layout: Utils.loadComponent('proxy/Layout'),
    VehicleSummary: Utils.loadComponent('entities/vehicle/VehicleSummary'),
    BookingButtons: Utils.loadComponent('BookingButtons'),
  },
  name: 'Vehicle',
})

export default class Vehicle extends Vue {
  @State('profile') public profileState!: ProfileState
  @State((state) => state.configuration.appConfig.fields_configuration) public fieldConfigState!: any
  @State((state) => state.configuration.appConfig.time_slot_dimension) public timeSlot!: any
  @Action('openPopup') public openPopup: any
  @Action('closePopup') public closePopup: any
  @Action('setZone') public setZone!: (id: string) => Promise<void>
  @Action('openDialog') public openDialog: any
  @Action('closeDialog') public closeDialog: any
  @Action('cleanVehicleSlot') public cleanVehicleSlot: any
  @Action('vehicleAvailability') public vehicleAvailability: any
  @Action('bookEstimate') public bookEstimate: any
  @Action('getUserMesh') public getUserMesh: any
  @Action('book') public bookAction!: (payload: BookRequest) => Promise<ReservationResponse>
  @Action('selectReservation') public selectReservation!: any

  @Prop() public vehicleSlot!: VehicleSlot

  public reservation?: ReservationResponse
  protected bookRequest: BookRequest = {start: null, end: null, memo: null, plate: null}
  protected availability: AvailabilityResponse[] = []
  protected loading: boolean = true

  public mounted() {
    this.setZone(this.vehicleSlot.id)
    this.bookRequest.plate = this.vehicleSlot.vehicle.plate
    this.getAvailability()
    EventBus.$on('quickBookingDateSelected', () => {
      this.closeDialog()
      this.book()
    })
    this.loading = false
  }

  protected destroyed() {
    EventBus.$off('quickBookingDateSelected')
  }

  protected sendBooking(callback?: () => void) {
    this.bookAction(this.bookRequest)
      .then((r) => {
        this.reservation = r
        // console.log(r)
        this.openPopup(new PopupState(
          VehicleConfirmBooking, {vehicleSlot: this.vehicleSlot, confirmCallback: callback}, null, true))
      })
      .catch(() => {
        return '💩'
      })
  }

  protected book(callback?: () => void) {
    return this.openDialog(new DialogState(VehicleBookingAddMemoDialog, {
      vehicle: this.vehicleSlot.vehicle,
      bookRequest: this.bookRequest,
      confirmCallback: () => {
        if (callback !== undefined) {
          this.sendBooking(callback)
        } else {
          this.sendBooking(() => {
            this.selectReservation(this.reservation)
            this.$router.push({name: 'reservation'})
          })
        }
      },
    }))
  }

  protected booking() {
    this.openDialog(new DialogState(VehicleBookingDateTimeSelect, {
      vehicleSlot: this.vehicleSlot,
      bookRequest: this.bookRequest,
    }, null, false, 'quickBookingDateSelected'))
  }

  protected quickBooking() {
    this.loading = true

    const openQuickBooking = () => {
      this.openDialog(new DialogState(QuickBookDialog, {
        vehicleSlot: this.vehicleSlot,
        availability: this.availability,
        onConfirm: ((req: BookTimeSelectRequest) => {
          this.bookRequest.start = req.start
          this.bookRequest.end = req.end
          this.closeDialog()
          this.book()
        }),
      }, null, false))
    }
    const availabilityStillValid = moment().isBefore(this.availability[0].end)

    if (availabilityStillValid) {
      openQuickBooking()
      this.loading = false
    } else {
      this.getAvailability().then(openQuickBooking).finally(() => {
        this.loading = false
      })
    }
  }

  protected getAvailability() {
    const now = DateHelper.parse(DateHelper.now('YYYY-MM-DD HH:mm:ss'))
    const start = now.minute(now.minute() - now.minute() % this.timeSlot).seconds(0).unix()
    const end = now.add(2, 'days').unix()
    const ar: AvailabilityRequest = {
      vehicle_id: this.vehicleSlot.vehicle.id,
      start,
      end,
    }
    return this.vehicleAvailability(ar).then((r: AvailabilityResponse[]) => {
      this.availability = r
    })
  }
}
